import { useMutation } from '@tanstack/react-query';

import { startVisitCheck } from '@/services/main/rezept/visitCheckService';
import type { VisitCheckFilters, VisitCheckStartResponse } from '@/types/visitCheck.types';

import { useClinicContext } from './useClinicContext';

/**
 * Mutation hook — start a 訪問データチェック session.
 * Returns either {has_data: false} (no matches) or {has_data: true, token, total}.
 */
export const useStartVisitCheckMutation = () => {
  const { tenant, clinicNumber } = useClinicContext();

  return useMutation<VisitCheckStartResponse, Error, VisitCheckFilters>({
    mutationFn: filters => startVisitCheck(tenant, clinicNumber, filters),
  });
};

export default useStartVisitCheckMutation;
